<template>
	<el-form-item label="Поиск запчастей" label-position="top" style="margin: 0;">
		<el-select
			v-model="selectedItem"			
			filterable
			remote
			:disabled="disabled"
			placeholder="Артикул, наименование, производитель или группа запчастей"
			:remote-method="searchItemsAsync"
			v-loading="isAsyncOperationPending"
			v-on:keyup.enter="onSelectEnterKeyUp"
			@clear="onSelectCleared"
			@change="onItemSelected"
		>
			<template #empty>
				Ничего не найдено ☹️
				<div style="margin: .44rem 0;">
					<el-button type="primary" size="small" @click="onSearchItemsInCatalogsClick">Искать в каталогах</el-button>
				</div>
			</template>
			<template #footer>
				<kbd class="DocSearch-Commands-Key" style="background: var(--docsearch-key-gradient);">
					<svg width="15" height="15" aria-label="Enter key" role="img">
						<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2">
							<path d="M12 3.53088v3c0 1-1 2-2 2H4M7 11.53088l-3-3 3-3"></path>
						</g>
					</svg>
				</kbd>
			</template>
			<el-option
				v-for="item in foundItems"
				:key="item.id"
				:label="item.externalName"
				:value="item.id">				
				<text v-if="item.id">
					<strong>{{ item.partNumber.toUpperCase() }}</strong> {{ item.externalName }}, {{ item.manufacturer?.name }} 
				</text>
				<el-text v-else type="primary">
					Искать артикул '{{ searchItemsQuery }}' в каталогах
				</el-text>
			</el-option>
		</el-select>
	</el-form-item>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import axiosHelper from '@/helpers/axiosHelper';
import store from '@/store';
import ServiceJobOperationModel from '@/models/ServiceJobOperationModel';
import ItemModel from '@/models/ItemModel';

@Options({	
	props: {
		disabled: {
			type: Boolean,
			default: false
		}
	},
	emits: ['itemPicked', 'searchInCatalogs'],
})
export default class OrderItemsSearchComponent extends Vue {
	/** props **/
	disabled!: boolean;

	/** view-models */
	searchItemsQuery = '';
	selectedItem: ItemModel | null = null;
	foundItems: Array<ItemModel> | null = null;
	isAsyncOperationPending = false;

	dialogJobComponentOperationsVisible = false;
	componentOperations: Array<ServiceJobOperationModel> = [];
	selectedComponentOperationIds: Array<number> = [];

	/** constants */
	foundJobsSelectHttpClient = axiosHelper.createInstance(store.getters.jwt);

	async searchItemsAsync(query: string) : Promise<void> {
		if (!query?.length) {
			return;
		}

		this.searchItemsQuery = query;
		
		try {
			this.isAsyncOperationPending = true;
			const results = await this.foundJobsSelectHttpClient.get(`/api/items/search`, { params: { query } });
			if (!results.data?.length) {
				this.foundItems = [];				
				return;
			}
			this.foundItems = results.data.map((_: any) => new ItemModel(_));
			this.foundItems?.push(new ItemModel({id: 0}));
		} catch (e) {
			console.error(`Unable to search items query '${query}'`, e);
		} finally {
			this.isAsyncOperationPending = false;
		}
	}

	/** fires when user picked item from select dropdown */
	async onItemSelected(itemId: number) {
		if (!itemId) {
			this.selectedItem = null;			
			this.$emit('searchInCatalogs', this.searchItemsQuery);
			return;
		}
		const item = this.foundItems?.find(_ => _.id == itemId);
		if (!item) {
			return;
		}
		this.selectedItem = null;
		this.foundItems = null;
		this.$emit('itemPicked', item);
	}

	onSearchItemsInCatalogsClick(e: MouseEvent) {
		if (!this.disabled &&
			!this.isAsyncOperationPending && 
			this.searchItemsQuery?.length) {
			this.emitSearchInCatalogsEvent();
			e.stopPropagation();
		}
	}

	onSelectCleared() {
		this.selectedItem = null;
		this.foundItems = null;		
	}

	onSelectEnterKeyUp(e: KeyboardEvent) {
		if (!this.disabled &&
			!this.isAsyncOperationPending && 
			this.searchItemsQuery?.length &&
			!this.foundItems?.length) {
			this.emitSearchInCatalogsEvent();
			e.stopPropagation();
		}
	}

	emitSearchInCatalogsEvent() {
		this.$emit('searchInCatalogs', this.searchItemsQuery);
		this.selectedItem = null;
		this.foundItems = null;
	}
}
</script>